<template>
  <component :is="listComponent" class="grid list-inside space-y-1">
    <li v-for="(item, index) in block.items" :key="index" class="list-item">
      <ContentRenderer :content="item.content" />
    </li>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ListBlock } from '@backmarket/catalog-shared-artifacts'

import ContentRenderer from '../ContentRenderer.vue'

const props = defineProps<{
  block: ListBlock
}>()

const listComponent = computed(() => {
  return props.block.listType === 'unordered' ? 'ul' : 'ol'
})
</script>
